import UserManagement from "../js/components/userManagement/UserManagement.react";
export default UserManagement;
